'use strict';
const mmWidgets = require('./mm-widgets');

mmWidgets.fn.radioCheckerWidget = function (eventSource, eventName) {
	if (!eventSource || !eventName) {
		throw new Error('invalid-args');
	}
	return mmWidgets.each(this, function () {
		const element = this;
		eventSource.addEventListener(eventName, () => {
			element.domElements[0].checked = true;
		});
	});
};
